import { Grid, Input, PasswordInput, TextInput } from "@mantine/core";

import { CallToAction } from "@/components/CallToAction";
import { IMaskInput } from "react-imask";

interface SignUpFormProps {
  signUpForm: any;
}

export function SignUpForm({ signUpForm }: SignUpFormProps) {
  return (
    <>
      <Grid.Col span={{ md: 6 }}>
        <TextInput
          withAsterisk
          label="Nome"
          placeholder="Insira seu primeiro nome"
          {...signUpForm.getInputProps("firstName")}
        />
      </Grid.Col>
      <Grid.Col span={{ md: 6 }}>
        <TextInput
          withAsterisk
          label="Sobrenome"
          placeholder="Insira seu sobrenome"
          {...signUpForm.getInputProps("lastName")}
        />
      </Grid.Col>

      <Grid.Col span={{ md: 12 }}>
        <TextInput
          withAsterisk
          label="Email"
          placeholder="Insira seu email"
          {...signUpForm.getInputProps("email")}
        />
      </Grid.Col>
      <Grid.Col span={{ md: 12 }}>
        <PasswordInput
          withAsterisk
          label="Crie uma senha"
          placeholder="Crie sua senha"
          {...signUpForm.getInputProps("password")}
        />
      </Grid.Col>
      <Grid.Col span={{ md: 12 }}>
        <Input.Wrapper
          label="Whatsapp"
          withAsterisk
          {...signUpForm.getInputProps("phoneNumber")}
        >
          <Input
            component={IMaskInput}
            mask="(00) 00000-0000"
            {...signUpForm.getInputProps("phoneNumber")}
            placeholder="(00) 0 0000-0000"
          />
        </Input.Wrapper>
      </Grid.Col>
      <Grid.Col span={{ md: 12 }}>
        <Input.Wrapper
          label="CPF"
          withAsterisk
          {...signUpForm.getInputProps("document")}
        >
          <Input
            component={IMaskInput}
            mask="000.000.000-00"
            {...signUpForm.getInputProps("document")}
            placeholder="000.000.000-00"
          />
        </Input.Wrapper>
      </Grid.Col>
      <Grid.Col span={{ md: 12 }}>
        <Input.Wrapper
          label="Data de Nascimento"
          withAsterisk
          {...signUpForm.getInputProps("birthdate")}
        >
          <Input
            component={IMaskInput}
            mask="00/00/0000"
            {...signUpForm.getInputProps("birthdate")}
            placeholder="DD/MM/AAAA"
          />
        </Input.Wrapper>
      </Grid.Col>

      <Grid.Col span={{ md: 12 }}>
        <CallToAction w="100%">Criar Conta</CallToAction>
      </Grid.Col>
    </>
  );
}
